
import * as Yup from "yup";

export const ProductSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, "Mínimo de 2 caracteres")
		.max(30, "Máximo de 30 caracteres")
		.required("O nome é obrigatório"),
	description: Yup.string()
		.min(2, "Mínimo de 2 caracteres")
		.max(150, "Máximo de 150 caracteres")
		.required("A descrição é obrigatória"),
	dashboard_description: Yup.string()
		.min(2, "Mínimo de 2 caracteres")
		.max(100, "Máximo de 100 caracteres")
		.required("A descrição do dashboard é obrigatória"),
		
});
